import constants from "../../core/constants";

const isString = (text) => typeof text === "string";

class Trim {
  constructor() {
    return this.transform;
  }

  transform(text) {
    return isString(text) && text.length
      ? text.split(" ").splice(0, constants.defaultTrimWordsCount).join(" ")
      : text;
  }
}

const trimFnc = () => new Trim();

export default trimFnc;



// WEBPACK FOOTER //
// ./src/filters/trim/trim.filter.js